import RouteWithPageTitle, { RouteWithPageTitleProps } from './RouteWithPageTitle';
import { useAuthenticate } from './useAuthenticate';

const ProtectedRoute = (props: RouteWithPageTitleProps) => (useAuthenticate()
  ? <RouteWithPageTitle {...props} /> : <></>);

export default ProtectedRoute;
